import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllOptions } from "../../customisation-slice";
import WatchFront from "./watch-front";
import WatchBack from "./watch-back";
import FadeWrapper from "../fade-wrapper";
import { useWatchViewContext } from "../../providers/watch-view-provider";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  viewIndex: PropTypes.number.isRequired,
};

const WatchPreviewImageLayers = ({ viewIndex }) => {
  const options = useSelector(selectAllOptions);
  const { animationState } = useWatchViewContext();
  const defaultClasses = [
    "relative",
    "w-full",
    "h-5/6",
    "md:h-3/4",
    "lg:w-3/4",
    "flex",
    "justify-center",
    "items-center",
    "overflow-hidden",
  ];
  
  conditionallyAddStyles(viewIndex > 0, defaultClasses, "fade");

  return (
    <div className="flex-grow flex justify-center items-center">
      <FadeWrapper
        className={defaultClasses.join(" ")}
        animationState={animationState}
      >
        {viewIndex > 1 ? (
          <WatchBack viewIndex={viewIndex} engraving={options["engraving"]} />
        ) : (
          <WatchFront viewIndex={viewIndex} options={options} />
        )}
      </FadeWrapper>
    </div>
  );
};

WatchPreviewImageLayers.propTypes = propTypes;

export default WatchPreviewImageLayers;
